import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

const state = {
  storeId: 1,
  storeUrlPrefix: '',
  storeViews: [],
  currentStoreView: {
    countryName: '',
    countryCode: '',
    storeBaseUrl: '',
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
